<template>
    <v-autocomplete
        v-model="val"
        :items="items"
        :item-text="itemText"
        :item-value="itemValue"
        return-object
        :loading="loading"
        :placeholder="computedPlaceholder"
        :label="label"
        :search-input.sync="searchInput"
        @input="searchInput = null"
    />
</template>

<script>
import Model from '@/shared/orm/Model'

export default {
    props: {
        value: {
            required: true,
        },

        model: {
            required: true,
            validator: model => {
                return model instanceof Model
            },
        },

        'item-text': {
            required: true,
            type: String,
        },

        'item-value': {
            default: 'id',
        },

        label: {
            required: true,
        },

        placeholder: {
            default: null,
        },
    },

    data: () => {
        return {
            loading: false,
            items: [],
            searchInput: null,
        }
    },

    computed: {
        computedPlaceholder() {
            return (
                this.placeholder || this.$t('forms.placeHolders.typeToSearch')
            )
        },

        val: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },

    watch: {
        searchInput(val) {
            if (val === null) return
            if (this.loading) return

            this.loading = true

            this.search(val).finally(() => {
                this.loading = false
            })
        },
    },

    methods: {
        async search(val) {
            let res = await this.model.where('search', val).get()
            if (!res) return
            this.items = res.data
        },
    },

    created() {
        if (!this.val) this.search()
        //todo search selectedModel when this.val is true
    },
}
</script>

<style></style>
